import React from 'react';
import PropTypes from 'prop-types';
import { Button, IconButton, ResponsiveText } from '../../atoms';
import { StickyNav } from '../../molecules';
import { useOffer } from '../../offer';
import { ButtonContainer, StyledFooter } from './styles';

export const Footer = ({
  onBackButtonClick,
  forwardButtonText = 'Continue',
  onForwardButtonClick,
  isForwardButtonDisabled,
}) => {
  const offer = useOffer();
  const ctaTextWithDiscount = offer?.formattedAmount
    ? `${forwardButtonText} with ${offer.formattedAmount} off`
    : forwardButtonText;

  return (
    <StickyNav shown>
      <StyledFooter>
        <ButtonContainer aria-live="polite">
          {onBackButtonClick && (
            <IconButton
              aria-label="go to previous step"
              icon={{ iconName: 'arrow-left', size: '24px', alt: 'back' }}
              onClick={onBackButtonClick}
              type="button"
              variant="spinach"
            />
          )}
          <Button
            aria-label={ctaTextWithDiscount}
            disabled={isForwardButtonDisabled}
            onClick={onForwardButtonClick}
            fullWidth
            variant="spinach"
          >
            <ResponsiveText
              desktopText={forwardButtonText}
              mobileText={ctaTextWithDiscount}
            />
          </Button>
        </ButtonContainer>
      </StyledFooter>
    </StickyNav>
  );
};

Footer.displayName = 'OnboardingFooter';
Footer.propTypes = {
  onBackButtonClick: PropTypes.func,
  forwardButtonText: PropTypes.string,
  onForwardButtonClick: PropTypes.func,
  isForwardButtonDisabled: PropTypes.bool,
};
